import React from 'react'

export default ({type, className}) => {

    return <div className={'upload-badge ' + className || ''} >{type}</div>
}


// WEBPACK FOOTER //
// ./src/components/admin/data-import/upload-history-badge.jsx